import ReactDatepicker from 'react-datepicker';
import { deprecated } from '../../constants/texts';

export default class Datepicker extends React.PureComponent {
  componentDidMount() {
    console.warn('React Datepicker -- eDoCat pure usage -- ', deprecated);
  }

  render() {
    return <ReactDatepicker {...this.props} />;
  }
}
